module.exports = __webpack_public_path__ + "img/1-4.31667bbf.png";